import { render, staticRenderFns } from "./WorkPointCollapse.vue?vue&type=template&id=e205451a&"
import script from "./WorkPointCollapse.vue?vue&type=script&lang=js&"
export * from "./WorkPointCollapse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports